import * as S from './style';

export function UserImgUpdateIcon() {
  return (
    <S.UserImgUpdateIcon>
      <S.CustomIcon icon="camera" />
    </S.UserImgUpdateIcon>
  );
}
